export enum RimViews {
  valueAndCause,
  rimLines,
  vatAndPayment,
  counterExpertise,
  remark,
  communication,
  signing
}
